import { useCallback } from "react";
import type { GridEventListener, GridRowIdGetter } from "@mui/x-data-grid";
import type { Banking } from "features/openBanking/types";
import { useResourceContext } from "ui/widgets/Resource";

export const useOpenBankingResource = () => {
    const resource = useResourceContext();

    const onRowClick: GridEventListener<'rowClick'> = ({ row }) => resource.onOpen(row);

    const getRowId: GridRowIdGetter<Banking> = useCallback(({ pki }: Banking) => pki, []);

    return {
        ...resource,
        onRowClick,
        getRowId
    };
};

export default useOpenBankingResource;
